module.exports = __webpack_public_path__ + "img/sword-earth-06.c7dbe45d.png";